import Vue from 'vue'
import {
  Pagination,
  Dialog,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Menu,
  MenuItem,
  Input,
  InputNumber,
  Select,
  Option,
  OptionGroup,
  Button,
  Table,
  TableColumn,
  DatePicker,
  Breadcrumb,
  BreadcrumbItem,
  Form,
  FormItem,
  Tabs,
  TabPane,
  Icon,
  Upload,
  Link,
  Divider,
  Image,
  Backtop,
  Descriptions,
  DescriptionsItem,
  Loading,
  Scrollbar,
  Calendar,
  MessageBox,
  Avatar,
  Tree,
  Message,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  CheckboxButton,
  Row,
  Col,
  Tag,
  Popover,
  TimePicker,
  PageHeader,
  RadioButton,
  Result
} from 'element-ui'
import locale from 'element-ui/lib/locale/lang/zh-CN'

const components = [
  Pagination,
  Dialog,
  Button,
  Message,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Menu,
  TimePicker,
  CheckboxGroup,
  MenuItem,
  Input,
  InputNumber,
  Select,
  Option,
  OptionGroup,
  Table,
  TableColumn,
  DatePicker,
  Breadcrumb,
  BreadcrumbItem,
  Form,
  FormItem,
  Tabs,
  TabPane,
  Icon,
  Image,
  Divider,
  Tree,
  Link,
  Scrollbar,
  Backtop,
  Descriptions,
  DescriptionsItem,
  Upload,
  Avatar,
  Calendar,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxButton,
  Row,
  Col,
  MessageBox,
  Tag,
  Popover,
  PageHeader,
  RadioButton,
  Result
]

const Element = {
  install(Vue) {
    components.forEach(component => {
      Vue.component(component.name, component)
    })
  }
}

Vue.prototype.$message = Message
Vue.config.productionTip = false
Vue.use(Loading.directive)
Vue.use(Element, { locale, size: 'medium' })
